/**
 * The shapes names must have, shared by the server's schemas and the client's
 * forms: a form checks with the same pattern the server will, so what it
 * accepts the server accepts too.
 */

/** Lowercase letters, digits and inner hyphens: a DNS label. Site slugs and node names. */
export const SLUG_PATTERN = /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;

/** A fully qualified domain name, in lowercase. */
export const DOMAIN_NAME_PATTERN = /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$/;
